/**
 * The nodes of a shared home, listed under the machine that owns it.
 *
 *   owner, 2026-10-21, on the Machines list: 有重複的同一台機器的配對 … gmicloud 也有重複的.
 *
 * A Slurm cluster's compute nodes share its login node's home and each pair as a machine of their
 * own (the BFF's `sibling_of` names the home's device). Listed as equals beside the login node,
 * ip-10-1-51-40 under AWS-slurm2 read as a second pairing of AWS-slurm2. Each home keeps its place
 * in the list and its nodes follow it; a node whose home is not on the list stays where it was.
 */
export type Placed<T> = { d: T; homeOf: T | null }

export function nodesUnderHomes<T extends { device_id: string; sibling_of?: string | null }>(
  devices: readonly T[],
): Placed<T>[] {
  const byId = new Map(devices.map((d) => [d.device_id, d]))
  const homeOf = (d: T): T | null => {
    const h = d.sibling_of ? byId.get(d.sibling_of) : undefined
    return h && h.device_id !== d.device_id && !h.sibling_of ? h : null
  }
  const out: Placed<T>[] = []
  for (const d of devices) {
    if (homeOf(d)) continue
    out.push({ d, homeOf: null })
    for (const n of devices) if (homeOf(n) === d) out.push({ d: n, homeOf: d })
  }
  return out
}
